import { combineReducers } from 'redux';

import alert from 'reducers/common/alert';
import mypageLogin from 'reducers/mypage/login';
import mypageHistory from 'reducers/mypage/history';
import mypageReceipt from 'reducers/mypage/receipt';
import orderAggregatorsPurchase from 'reducers/orderAggregators/purchase';
import orderAggregatorsConfirmation from 'reducers/orderAggregators/confirmation';
import orderAggregatorsQuotation from 'reducers/orderAggregators/quotation';
import contact from 'reducers/contact';

export default combineReducers({
  alert,
  mypageLogin,
  mypageHistory,
  mypageReceipt,
  orderAggregatorsPurchase,
  orderAggregatorsConfirmation,
  orderAggregatorsQuotation,
  contact
});



// WEBPACK FOOTER //
// ./src/reducers/index.js